import React, { useState } from "react";
import PreviewPopupTable from "./PreviewPopupTable";
import CommonLayout from "../CommonLayout";

const EditPartAction = ({ prevData, newData }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [partData, setPartData] = useState({});
  const fieldsData = [
    { colKey: "type_name", colText: "Type" },
    { colKey: "part_number", colText: "Item Code" },
    { colKey: "description", colText: "Description" },
    { colKey: "table_note", colText: "Table Note", printInNewLine: true },
    { colKey: "textbox_note", colText: "Text Box Note", printInNewLine: true },
    { colKey: "default_unit_show", colText: "Default Unit" },
    { colKey: "url", colText: "URL" },
  ];

  const showPopupHanldel = (data) => {
    setPartData(data);
    setShowPopup(true);
  };

  return (
    <>
      <CommonLayout
        prevData={prevData}
        newData={newData}
        fieldsData={fieldsData}
        showPopupHanldel={showPopupHanldel}
      />
      {showPopup && (
        <PreviewPopupTable
          part={partData}
          hidePopup={() => {
            setShowPopup(false);
          }}
        />
      )}
    </>
  );
};

export default EditPartAction;
